import React from 'react';
import TextLabel from '../textLabel';
import InputValidationErrorSymbol from '../inputValidationError.svg.js';
import InputValidationSuccessSymbol from '../inputValidationSuccess.svg.js';
export default function () {
  return this.isStatusNone() ? null : /*#__PURE__*/React.createElement("div", {
    className: "upload-status-message",
    key: "showStatusMessage"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    value: this.getMessage(),
    shouldTranslate: this.shouldTranslateMainMessage(),
    type: "T07",
    ellipsisProps: this.getEllipsisProps()
  }), this.isStatusUploadSuccess() ? /*#__PURE__*/React.createElement(TextLabel, {
    key: "showFileExtension",
    value: this.getFileExtension(),
    shouldTranslate: false,
    type: "T07",
    enableEllipsis: false
  }) : null, /*#__PURE__*/React.createElement("span", {
    className: "status-icon"
  }, this.isStatusUploadSuccess() ? /*#__PURE__*/React.createElement(InputValidationSuccessSymbol, {
    key: "showSuccessSymbol"
  }) : null, this.isStatusUploadFailed() ? /*#__PURE__*/React.createElement(InputValidationErrorSymbol, {
    key: "showFailedSymbol"
  }) : null));
}